import React, { useCallback, useMemo } from 'react';
import { Spacer, SettingsItem, SettingsItemTitle, SettingsItemContent, SettingsItemDescription } from 'design-system';
import Text from 'design-system/Text';
import LogoBankAccount from 'design-system/LogoBankAccount';
import { IconEnergyBolt } from 'design-system/icons/IconEnergyBolt';
import IconTransfer from 'design-system/icons/IconTransfer';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectShowISATransfers, selectTradingAccountObjFromId } from '../reducers/selectors';
/** Legacy name. It is for both GIA and ISA. */
const TopUpGiaAccountModalContent = ({ hideModal, tradingAccountId, accountType }) => {
    const navigation = useMainStackNavigation();
    const connectedAccount = useAppSelector((state) => state.invest.connectedAccount);
    const showISATransfers = useAppSelector(selectShowISATransfers);
    const tradingAccount = useAppSelector((state) => selectTradingAccountObjFromId(state, tradingAccountId));
    const hasFunded = tradingAccount?.hasFunded;
    const handleEasyTransfer = useCallback(() => {
        hideModal(() => {
            navigation.navigate('AddMoneyToTradingAccount', { tradingAccountId });
        });
    }, [hideModal, tradingAccountId]);
    const goToProductTransfer = useMemo(() => showISATransfers && accountType === 'ISA' && hasFunded
        ? () => hideModal(() => {
            navigation.navigate('ProductTransferIntro');
        })
        : undefined, [accountType, hasFunded, hideModal, showISATransfers]);
    return (<>
      <Spacer h={8}/>
      <SettingsItem iconSize={44} onPress={handleEasyTransfer} icon={connectedAccount ? (<LogoBankAccount data={connectedAccount} size="R44"/>) : (<IconEnergyBolt gradientKey="darkPurple"/>)}>
        <SettingsItemContent>
          <Text Text-12 Primary>
            RECOMMENDED
          </Text>
          <SettingsItemTitle>Open Banking Transfer</SettingsItemTitle>
          <SettingsItemDescription>
            Quickly and securely deposit money without entering bank details
          </SettingsItemDescription>
        </SettingsItemContent>
      </SettingsItem>
      {goToProductTransfer !== undefined && (<SettingsItem onPress={goToProductTransfer} icon={<IconTransfer alt gradientKey="skyBlue"/>} title="Transfer an ISA" description="Bring your ISAs together for easier management"/>)}
    </>);
};
export default TopUpGiaAccountModalContent;
